import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useBreakpoint } from '@panel/commons';
import { ModuleWrapper } from '../../../Wrappers/ModuleWrapper';
import {
  Subtitle,
  SectionContainer,
  ButtonsContainer,
  InputVideo,
  ErrorMessage,
  AddButton,
  VideoList,
  Video,
  VideoDetail,
  TrashIcon
} from './styles';
import {
  getVideos360,
  addMultimedia,
  MultimediaType,
  MultimediaCollection,
  deleteMultimedia
} from '../../../../ducks/step2';

export const Videos360 = ({
  register,
  errors,
  trigger,
  setValue,
  getValues,
  emptyInputs,
  setEmptyInputs,
  setValidateVideo,
  validateVideo
}) => {
  const { tour360 } = useSelector(getVideos360);
  const [reachedBreakPoint] = useBreakpoint(1280);
  const { empty360 } = emptyInputs;
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    const addVideo = () => {
      const videoUrl = getValues('video360');

      const objVideo = {
        key_video: videoUrl,
        multimediaType: MultimediaType.TOUR360
      };
      setValue('video360', '');
      return objVideo.key_video && dispatch(addMultimedia(objVideo, MultimediaCollection.VIDEO360));
    };

    const triggerAddVideo = async () => {
      const videoUrl = getValues('video360');
      if (videoUrl === '' && !empty360) {
        setEmptyInputs({ ...emptyInputs, empty360: true });
      } else if (videoUrl !== '' && empty360) {
        setEmptyInputs({ ...emptyInputs, empty360: false });
      }
      const result = await trigger('video360');
      if (result) {
        return addVideo();
      }
      return null;
    };
    if (validateVideo) {
      triggerAddVideo();
    }
    return setValidateVideo(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setValidateVideo, validateVideo]);

  const deleteVideo = id => {
    return dispatch(deleteMultimedia(id, MultimediaCollection.VIDEO360));
  };

  return (
    <ModuleWrapper title={t('publisher.step2.module4.video.title')}>
      <Subtitle data-repa='step2-video360-subtitle'>{t('publisher.step2.module4.video.text')}</Subtitle>
      <SectionContainer data-repa='step2-video360-sectionContainer'>
        <ButtonsContainer data-repa='step2-video360-buttonContainer'>
          <InputVideo
            data-repa='step2-360-input'
            className={errors.video360 && 'error'}
            type='text'
            disabled={tour360.length === 1}
            name='video360'
            onKeyPress={evt => {
              if (evt.key === 'Enter') evt.preventDefault();
            }}
            ref={register}
            placeholder={t('publisher.step2.module4.video.placeholder')}
          />
          <AddButton
            data-repa='step2-360-button-add'
            type='button'
            disabled={tour360.length === 1}
            onClick={() => {
              if (tour360.length < 1) {
                setValidateVideo(true);
              }
            }}
          >
            {t('publisher.step2.module3.video.additionalVideo')}
          </AddButton>
          {errors.video360 && errors.video360.type === 'checkUrl' && (
            <ErrorMessage data-repa='step2-video360-error-invalidUrl'>
              {t(`publisher.step2.module3.video.validation.invalidUrl.${reachedBreakPoint ? 'd' : 'm'}`)}
            </ErrorMessage>
          )}
          {empty360 && (
            <ErrorMessage data-repa='step2-video360-error-empty'>
              {t('publisher.step2.module3.video.validation.inputEmpty')}
            </ErrorMessage>
          )}
        </ButtonsContainer>
        <VideoList data-repa='step2-360-itemlist' videos={tour360.length}>
          {tour360.map(video => (
            <Video data-repa={`step2-360-itemlist-item-${video.order}`} key={video.key_video}>
              <iframe
                data-repa={`step2-360-itemlist-item-${video.order}-iframe`}
                title={video.videoId}
                width='100%'
                height='100%'
                src={video.key_video}
                frameBorder='0'
                allowFullScreen=''
              />
              <VideoDetail data-repa={`step2-360-itemlist-item-${video.order}-videoDetail`}>
                <span data-repa={`step2-360-itemlist-item-${video.order}-videoDetail-span`}>{video.key_video}</span>
                <TrashIcon
                  data-repa={`step2-360-itemlist-item-${video.order}-button-delete`}
                  onClick={() => deleteVideo(video.id)}
                />
              </VideoDetail>
            </Video>
          ))}
        </VideoList>
      </SectionContainer>
    </ModuleWrapper>
  );
};
